export default __webpack_public_path__ + "static/media/screen_04.406f9d1d.png";